import { InputType } from '../app/features/BulkWorkflowForm/types';
import { ListDetails, ListState } from '../listoramaAdmin-api/generated-src';

const LIST_CONST_REGEX = new RegExp(`^ls[0-9]{7,19}$`);
const T_CONST_REGEX = new RegExp(`^tt[0-9]{7,19}$`);
const N_CONST_REGEX = new RegExp(`^nm[0-9]{7,19}$`);
const VIDEO_CONST_REGEX = new RegExp(`^vi[0-9]{7,19}$`);
const IMAGE_CONST_REGEX = new RegExp(`^rm[0-9]{7,10}$`);
const U_CONST_REGEX = new RegExp(`^ur[0-9]{7,9}$`);
const CUSTOMER_ID_REGEX = new RegExp(`^A[A-Z0-9]{1,63}$`);
const NUMERIC_REGEX = new RegExp(`^[0-9]+$`);

export const validateListConst = (lconst: string): boolean => LIST_CONST_REGEX.test(lconst);
export const validateTConst = (liconst: string): boolean => T_CONST_REGEX.test(liconst);
export const validateNConst = (liconst: string): boolean => N_CONST_REGEX.test(liconst);
export const validateVideoConst = (liconst: string): boolean => VIDEO_CONST_REGEX.test(liconst);
export const validateImageConst = (liconst: string): boolean => IMAGE_CONST_REGEX.test(liconst);
export const validateUconst = (uconst: string): boolean => U_CONST_REGEX.test(uconst);
export const validateCustomerId = (customerId: string): boolean => CUSTOMER_ID_REGEX.test(customerId);
export const validateNumber = (numericalString: string): boolean => NUMERIC_REGEX.test(numericalString);

export const validateInputId = (inputId: string, inputType: InputType): boolean => {
    if (inputType === InputType.CUSTOMER_ID) {
        return validateCustomerId(inputId);
    } else if (inputType === InputType.LIST_ID) {
        return validateListConst(inputId);
    } else if (inputType === InputType.USER_ID) {
        return validateUconst(inputId);
    }
    return false;
};

const SEED_LIST_CLASSES = ['LIST', 'WATCHLIST', 'CHECKINS'];

/**
 * Validates a SEED_LIST_ITEMS CSV row: userId,listClass,size[,allowDuplicates][,listId].
 * userId, listClass and size are required; allowDuplicates and listId are optional (may be empty).
 */
export const validateSeedListItemsRow = (row: string): boolean => {
    const parts = row.split(',').map((part) => part.trim());
    if (parts.length < 3) {
        return false;
    }
    const [userId, listClass, size, allowDuplicates, listId] = parts;
    if (!validateUconst(userId)) {
        return false;
    }
    if (!SEED_LIST_CLASSES.includes(listClass.toUpperCase())) {
        return false;
    }
    if (!validateNumber(size) || Number(size) <= 0) {
        return false;
    }
    if (allowDuplicates && !['true', 'false'].includes(allowDuplicates.toLowerCase())) {
        return false;
    }
    if (listId && !validateListConst(listId)) {
        return false;
    }
    return true;
};

export const isListVisibleToPublic = (list: ListDetails): boolean => list.publik && list.state === ListState.Ok;
